import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './SubmissionErrorModal.css';
import TauriImage from '../../TauriImage/TauriImage';

const SubmissionErrorModal = ({ show, onHide, validationMes }) => {
    if (!validationMes) return null;
    
    return (
        <Modal className="submission-error-modal" show={show} onHide={onHide} size="lg" centered>
            <Modal.Header>
                Submission Error
            </Modal.Header>
            <Modal.Body>
                <p>The following criterias based on company policy are not met:</p>

                <div className="section-title px-3">PLOTTING</div>
                <div className="separator-line" />

                {/* Stoppers */}
                {validationMes?.stoppers?.map((err) => (
                    <div className="error-item" key={err.code}>
                        <TauriImage
                            localImage={"/Images/material-symbols--warning.svg"}
                            alt="icon"
                            color={"#DA0000"}
                        />
                        <div>{err.errorMessage}</div>
                    </div>
                ))}

                {/* Warnings */}
                {validationMes?.warnings?.map((warn) => (
                    <div className="error-item" key={warn.code}>
                        <TauriImage
                            localImage={"/Images/material-symbols--warning.svg"}
                            alt="icon"
                            color={"#FD9B08"}
                        />
                        <div>{warn.errorMessage}</div>
                    </div>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <Button className="submission-error-close" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SubmissionErrorModal;
